import styled from "@emotion/styled";

type StyledTableWrapperType = {
  $gridTemplateColumns: string;
  $columnsCount: number;
  $hasHeader: boolean;
};

const StyledTableWrapper = styled.div<StyledTableWrapperType>`
  display: grid;
  grid-template-columns: ${(props) => props.$gridTemplateColumns};
  gap: ${(props) => props.theme.spacing(1, 0)};
  margin-top: ${(props) => props.theme.spacing(2)};

  & > div {
    border-bottom: 1px solid;
  }

  ${(props) =>
    props.$hasHeader &&
    `

    &> div:nth-of-type(${props.$columnsCount}) {
    }
  `}

  &
    > div:nth-of-type(
      ${(props) => props.$columnsCount}n
        + ${(props) => (props.$hasHeader ? props.$columnsCount + 1 : 1)}
    ) {
    border-left: 0;
  }

  &
    > div:nth-of-type(
      ${(props) => props.$columnsCount}n
        + ${(props) => props.$columnsCount * (props.$hasHeader ? 2 : 1)}
    ) {
    border-right: 0;
    padding-right: ${(props) => props.theme.spacing(1)};
  }
`;

const StyledHeaderCell = styled.div<{ $justifySelf?: string; $condensed?: boolean }>`
  padding: ${(props) => (props.$condensed ? "" : props.theme.spacing(3, 0, 3, 0))};
  color: ${(props) => props.theme.palette.text.secondary};
  border-color: ${(props) => props.theme.colors.border} !important;
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.$justifySelf ?? ""};
`;

const StyledCell = styled.div<{
  $justifySelf?: string;
  $borderColor: string;
  $clickable: boolean;
  $condensed?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.$justifySelf ?? ""};
  padding: ${(props) => (props.$condensed ? "" : props.theme.spacing(1, 3.5, 1, 0))};
  border-color: ${(props) => props.theme.colors.border} !important;
  font-weight: 500;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  ${(props) => (props.$condensed ? "" : "min-height: 72px;")}
`;

const StyledNoData = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray};
  padding: ${(props) => props.theme.spacing(3)};
`;

export { StyledCell, StyledHeaderCell, StyledTableWrapper, StyledNoData };
